// Mise à jour automatique de l'app (PWA) sans réinstallation.
// Stratégie : détecter un nouveau déploiement en comparant le hash du bundle JS
// principal présent dans index.html, puis recharger automatiquement (anti-boucle).
// + force la mise à jour du Service Worker et recharge sur changement de contrôleur.

const BUNDLE_RE = /\/static\/js\/main\.[A-Za-z0-9]+\.js/;
let currentBundle = null;
let reloading = false;

function readLoadedBundle() {
    const scripts = Array.from(document.querySelectorAll('script[src]'));
    for (const s of scripts) {
        const m = (s.getAttribute('src') || '').match(BUNDLE_RE);
        if (m) return m[0];
    }
    return null;
}

function doReload(targetBundle) {
    if (reloading) return;
    reloading = true;
    try { sessionStorage.setItem('app_update_target', targetBundle || ''); } catch (e) { /* ignore */ }
    // Recharge en contournant le cache HTTP
    window.location.reload();
}

async function checkForNewDeploy() {
    if (reloading || document.visibilityState === 'hidden') return;
    try {
        const res = await fetch('/index.html?_=' + Date.now(), { cache: 'no-store' });
        if (!res.ok) return;
        const html = await res.text();
        const m = html.match(BUNDLE_RE);
        const latest = m ? m[0] : null;
        if (!latest || !currentBundle) return;
        if (latest !== currentBundle) {
            // Évite une boucle : ne recharge pas deux fois pour la même cible
            let already = null;
            try { already = sessionStorage.getItem('app_update_target'); } catch (e) { /* ignore */ }
            if (already === latest) return;
            console.log('[AppUpdate] Nouvelle version détectée → rechargement', { currentBundle, latest });
            doReload(latest);
        }
    } catch (e) {
        /* hors-ligne ou erreur réseau : on ignore */
    }
}

export function initAutoUpdate() {
    currentBundle = readLoadedBundle();

    // Si on vient de recharger pour atteindre une cible et qu'on y est, on nettoie le garde-fou
    try {
        const target = sessionStorage.getItem('app_update_target');
        if (target && target === currentBundle) sessionStorage.removeItem('app_update_target');
    } catch (e) { /* ignore */ }

    // 1) Service Worker : update + rechargement sur changement de contrôleur
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/sw.js', { scope: '/' }).then((reg) => {
            const triggerUpdate = () => { try { reg.update(); } catch (e) { /* ignore */ } };
            triggerUpdate();
            // Quand un nouveau SW est prêt, on l'active immédiatement
            reg.addEventListener('updatefound', () => {
                const nw = reg.installing;
                if (!nw) return;
                nw.addEventListener('statechange', () => {
                    if (nw.state === 'installed' && navigator.serviceWorker.controller) {
                        nw.postMessage && nw.postMessage({ type: 'SKIP_WAITING' });
                    }
                });
            });
            // Vérifie périodiquement la présence d'un nouveau SW
            setInterval(triggerUpdate, 60 * 1000);
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') triggerUpdate();
            });
        }).catch(() => {});

        let refreshed = false;
        // Ne recharger QUE si la page était déjà contrôlée par un SW (= vraie mise à jour),
        // pas au tout premier enregistrement (sinon rechargement parasite à la 1re visite).
        const hadController = !!navigator.serviceWorker.controller;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (refreshed || !hadController) return;
            refreshed = true;
            if (!reloading) { reloading = true; window.location.reload(); }
        });
    }

    // 2) Détection de déploiement par hash du bundle (indépendant du SW)
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') checkForNewDeploy();
    });
    window.addEventListener('focus', checkForNewDeploy);
    setInterval(checkForNewDeploy, 3 * 60 * 1000);
    // Premier check après le chargement initial
    setTimeout(checkForNewDeploy, 15 * 1000);
}
